import _ from 'lodash';
//import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import Checkbox from '@material-ui/core/Checkbox';

import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

import RebateCampaignContainer from '../../containers/rebateCampaigns/RebateCampaigns';
import StationsContainer from '../../containers/Stations';

import FormComponent from '../../components/FormComponent';
import FMPText from '../../components/pureForm/FMPText';
import FMPStationAutoComplete from '../../components/pureForm/FMPStationAutoComplete';
import { sortStationsByNumber } from '../../libs/utility';

//import Switch from '@material-ui/core/Switch';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
	};
};

function sortStationIdsByStationOrder(stationIds, sortedStations) {
	console.log('sortedStations', sortedStations);
	// Build a lookup: stationId → its position in the sorted list
	const orderMap = new Map(sortedStations.map((s, idx) => [s.stationId, idx]));

	// Sort a shallow copy of the ID list using that lookup
	return [...stationIds].sort((a, b) => {
		const idxA = orderMap.get(a);
		const idxB = orderMap.get(b);

		// If either ID wasn’t in the sorted list, shove it to the end
		if (idxA === undefined && idxB === undefined) return 0;
		if (idxA === undefined) return 1;
		if (idxB === undefined) return -1;

		return idxA - idxB;
	});
}

// XXX Update does not work

class SaveRebateCampaign extends FormComponent {
	constructor(props) {
		super(props);
		const rebateCampaignId = _.get(this.props, ['match', 'params', 'rebateCampaignId']);

		this.state = {
			rebateCampaignId: rebateCampaignId ? parseInt(rebateCampaignId, 10) : undefined,
			name: '',
			stations: [
				{
					stationId: null,
				},
			],
			isUpdate: rebateCampaignId,
			formFieldError: {},
		};
	}

	componentDidMount() {
		const { rebateCampaign, rebateCampaignGet } = this.props;

		const { isUpdate, rebateCampaignId } = this.state;
		if (_.isEmpty(this.props.stations)) {
			this.props.searchStations();
		}

		if (!isUpdate) {
			return;
		}

		if (!rebateCampaign) {
			rebateCampaignGet({
				params: { rebateCampaignIds: [rebateCampaignId] },
			});
		} else {
			const newState = this.getFormValuesFromRebateCampaign();
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.rebateCampaign) && !_.isUndefined(this.props.rebateCampaign)) {
			const newState = this.getFormValuesFromRebateCampaign();
			this.setState(newState);
		}
	}

	getFormValuesFromRebateCampaign = () => {
		const { rebateCampaign, stationMap } = this.props;
		if (!rebateCampaign) {
			return;
		}

		const formValues = {};
		['name'].forEach((key) => {
			if (_.isNil(rebateCampaign[key])) {
				return;
			}
			formValues[key] = rebateCampaign[key];
		});

		const stationIds = rebateCampaign.stationIds;

		console.log('stationMap', stationMap);

		const sortedStations = sortStationsByNumber(_.values(stationMap));
		console.log('sortedStations', sortedStations);
		const orderedIds = sortStationIdsByStationOrder(stationIds, sortedStations);
		formValues.stations = orderedIds.map((stationId) => {
			return { stationId };
		});
		return formValues;
	};

	addInput = (arrayName) => {
		this.setState({ [arrayName]: this.state[arrayName].concat({ stationId: 0 }) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	handleSave = () => {
		const { rebateCampaignAdd, rebateCampaignUpdate, showErrors } = this.props;

		//- Required fields
		const formFieldError = {};
		[{ fieldName: 'name', display: 'Name' }].forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		//- Get all the values and do individual checks
		const { name, stations, rebateCampaignId, isUpdate } = this.state;

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const stationIds = stations.map(({ stationId }) => {
			return stationId;
		});

		//- Lock and load
		const params = {
			name,
			stationIds,
		};

		if (!isUpdate) {
			rebateCampaignAdd({ params });
		} else {
			params.rebateCampaignId = rebateCampaignId;
			rebateCampaignUpdate({ params });
		}
	};

	render() {
		const { classes, rebateCampaign, stations } = this.props;

		const { isUpdate } = this.state;

		if (!stations.length) {
			return <div>Fetching information...</div>;
		}

		if (isUpdate && !rebateCampaign) {
			return <div>Bulk customer information...</div>;
		}
		const verb = isUpdate ? 'Update' : 'Add';

		console.log('station', this.state.stations);
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{verb} Rebate Campaign
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Campaign Info</div>

						<FMPText {...this.setForm('name', 'Campaign Name', true)} />

						<div className={classes.sectionHeader}>Stations</div>
						{this.state.stations.map((station, i) => {
							const path = `stations.${i}.stationId`;
							return (
								<Grid key={i} container spacing={3}>
									<FMPStationAutoComplete
										{...this.setForm(path, 'Station', true)}
										stations={this.props.stations || []}
										md={6}
									/>

									<Grid item xs={1}>
										<IconButton
											color="primary"
											className={classes.button}
											onClick={() => this.removeInput('stations', i)}
										>
											<DeleteIcon />
										</IconButton>
									</Grid>
								</Grid>
							);
						})}

						<Button
							variant="contained"
							className={classes.addInputButton}
							onClick={() => this.addInput('stations')}
						>
							Add Station To Campaign
						</Button>

						<div style={{ textAlign: 'right' }}>
							<Button
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSave}
							>
								{verb} Rebate Campaign
							</Button>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

SaveRebateCampaign.propTypes = {
	rebateCampaign: PropTypes.object,
	rebateCampaignGet: PropTypes.func.isRequired,
	rebateCampaignAdd: PropTypes.func.isRequired,
	rebateCampaignUpdate: PropTypes.func.isRequired,
	stationMap: PropTypes.object,

	searchStations: PropTypes.func.isRequired,
	stations: PropTypes.array,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	RebateCampaignContainer,
	StationsContainer,
])(SaveRebateCampaign);
